import type { ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../api-tags';
import { CUSTOMER_ID_PATH_PARAMS } from '../customer-id-path';

export const UPDATE_CUSTOMER_CHILDREN_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: '/customer/{customerId}/children',
  pathParams: CUSTOMER_ID_PATH_PARAMS,
  tags: NEST_API_TAGS.CUSTOMER,
} satisfies ZapiPath;

export type UpdateCustomerChildrenPath = typeof UPDATE_CUSTOMER_CHILDREN_PATH;